import { AuthService } from '../services/AuthService';
import { Button, Container, Heading, Image, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import { TelemetryClientService } from '../services/TelemetryClientService';
import { ButtonLink } from '../navbar/ButtonLink';
import { TEMPLATE } from '@/shared/constants';
import React from 'react';
import { AppContext } from '../comments/AppContext';
import { AppBreadcrumb } from '../navbar/AppBreadcrumb';
import { useNavigate } from 'react-router-dom';
import { AppLinkBar } from '../navbar/AppLinkBar';

export const Hero = () => {

  TelemetryClientService.page('WelcomePage');

  const { isAuthenticated } = React.useContext(AppContext);

  const breadcrumb = React.useMemo(() => [
    { label: 'Home', href: '/' }
  ], []);

  const navigate = useNavigate();

  const onLogin = () => {
    AuthService.loginPopup().then(() => {
      navigate('/courses');
    })
  }

  return <>
    <AppBreadcrumb breadcrumb={breadcrumb} />
    <AppLinkBar />
    <Container mt='80px' py={{ base: '16', md: '24' }}>
      <SimpleGrid minH={{ base: '40vh', xl: '50vh' }} columns={{ base: 1, md: 2 }} gap={16}>
        <Stack spacing={{ base: '8', md: '12' }} justifyContent='center'>
          <Stack spacing={{ base: '4', md: '6' }}>
            <Heading size={{ base: 'md', xl: 'lg' }}>EIT Label for Non-Degree Education and Learning</Heading>
            <Text fontSize={{ base: 'lg', md: 'xl' }} color="fg.muted">
              In receiving the EIT Label for non-degree education and training through successful
              accreditation of your course or programme you are able to demonstrate that it
              meets established quality criteria as defined within the Standard against which the
              EIT Label is awarded.
            </Text>
          </Stack>
          <Stack direction={{ base: 'column', md: 'row' }} spacing="3">
            {isAuthenticated
              ? <ButtonLink to="/courses" size={{ base: 'lg', md: 'xl' }} variant="primary">Go to the Dashboard</ButtonLink>
              : <>
                <Button onClick={onLogin} size={{ base: 'lg', md: 'xl' }}>Log In</Button>
                <ButtonLink to={`/page/${TEMPLATE.PAGE_ABOUT}`} variant="secondary" size={{ base: 'lg', md: 'xl' }}>Learn More</ButtonLink>
              </>
            }
         </Stack>
        </Stack>
        <Stack justifyContent='center'>
          <Image borderTopLeftRadius={50} borderTopRightRadius={0} borderBottomLeftRadius={0} borderBottomRightRadius={50} fit='cover' w='full' src="/eit2.png" alt="EIT Picture" />
        </Stack>
      </SimpleGrid>
    </Container>
  </>
}